import type { PaymentConfig, PaymentMethod } from '@/types/payment'

export function PaymentFormMethodSelector({
  paymentConfig,
  paymentMethod,
  onSelect,
}: {
  paymentConfig: PaymentConfig
  paymentMethod: PaymentMethod
  onSelect: (method: PaymentMethod) => void
}) {
  return (
    <div className="w-full md:w-1/4">
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <div className="p-4 bg-gray-50 border-b border-gray-200">
          <h3 className="font-semibold text-gray-700">Payment Method</h3>
        </div>
        <div className="divide-y divide-gray-100">
          {paymentConfig.cardconnect?.status && (
            <label className="flex items-center p-4 cursor-pointer hover:bg-gray-50 transition-colors">
              <input
                type="radio"
                name="paymentMethod"
                checked={paymentMethod === 'CARDCONNECT'}
                onChange={() => onSelect('CARDCONNECT')}
                className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300"
              />
              <span className="ml-3 text-sm font-medium text-gray-700">Credit Card</span>
            </label>
          )}
          {paymentConfig.paypal?.status && (
            <label className="flex items-center p-4 cursor-pointer hover:bg-gray-50 transition-colors">
              <input
                type="radio"
                name="paymentMethod"
                checked={paymentMethod === 'Paypal'}
                onChange={() => onSelect('Paypal')}
                className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300"
              />
              <span className="ml-3 text-sm font-medium text-gray-700">Paypal</span>
            </label>
          )}
        </div>
      </div>
    </div>
  )
}
